import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from 'components/Text';
import Box from 'components/Box';
import Flex from 'components/Flex';
import TextInput from 'components/TextInput';
import FormField from 'components/FormField';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CompletionTimeField = function CompletionTimeField(_ref) {
  var completionTime = _ref.completionTime,
    onChange = _ref.onChange,
    isDisabled = _ref.isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var basisTime = completionTime !== null && completionTime !== void 0 ? completionTime : 0;
  return /*#__PURE__*/_jsx(FormField, {
    label: t('form_completion_time'),
    horizontal: true,
    children: /*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsx(Box, {
        shrink: true,
        basis: 50 + (basisTime.toString().length - 1) * 10,
        mr: "xs",
        children: /*#__PURE__*/_jsx(TextInput, {
          stealthy: true,
          type: "number",
          value: completionTime !== null && completionTime !== void 0 ? completionTime : '',
          min: "0",
          onChange: onChange,
          disabled: isDisabled
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: t('minute_count', {
          count: completionTime
        })
      })]
    })
  });
};
export default CompletionTimeField;